<template>
  <iRow :max-width="1200" style="margin-top: 50px">
    <iRow
      v-if="publicationData.publication_logo"
      align="center"
    >
      <iColumn align="center">
        <iImageContainer
          :width="300"
          :src="publicationData.publication_logo"
        />
      </iColumn>
    </iRow>
    <iRow align="center">
      <iColumn align="center">
        <iDisplayText text-align="center">
          This link is invalid or has expired
        </iDisplayText>
        <iParagraph text-align="center">
          Please check your email for a new link
        </iParagraph>
      </iColumn>
    </iRow>
  </iRow>
</template>

<script>

export default {
  name: "CheckEmail",
  props: {
    publicationData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};

</script>
